export const brazilCoordinates = {
  longitude: -51.105673,
  latitude: -14.395535,
  zoom: 3.5,
}
